import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, BoxProps } from '@material-ui/core';
import { useAppPageBodyClassSetter } from '@components/AppPage/AppPageContext/AppPageContext';

export const HEADER_GRID_AREA = 'header';
export const BODY_GRID_AREA = 'body';
export const FOOTER_GRID_AREA = 'footer';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'grid',
		gridTemplateAreas: `
			"${HEADER_GRID_AREA}"
			"${BODY_GRID_AREA}"
			"${FOOTER_GRID_AREA}"
		`,
		gridTemplateRows: 'min-content minmax(325px, 1fr) min-content',
		backgroundColor: theme.palette.common.white,
		width: '100vw'
	},
}));

interface MainPageLayoutContainerProps extends BoxProps {
	children: React.ReactNode;
	pageName: string;
	bodyClass?: string;
}

const MainPageLayoutContainer: React.FC<MainPageLayoutContainerProps> = ({ children, pageName, bodyClass, ...boxProps }) => {
	const classes = useStyles();

	const { setBodyClass } = useAppPageBodyClassSetter(pageName);

	React.useEffect(() => {
		if (bodyClass) {
			setBodyClass(bodyClass);
		}
	}, [bodyClass, setBodyClass]);

	return (
		<Box className={classes.root} {...boxProps}>
			{children}
		</Box>
	);
};

export default MainPageLayoutContainer;
